import { useEffect, useState } from 'react';
import { MODAL_FORM_VIEW_TYPES } from '../../constants';

export const usePaymentFormModal = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [title, setTitle] = useState('');
  const [type, setType] = useState(MODAL_FORM_VIEW_TYPES.ADD);

  const showModal = (modalTitle: string, modalType: string) => {
    setTitle(modalTitle);
    setType(modalType);
    setIsOpenModal(true);
  };
  const hideModal = () => {
    setIsOpenModal(false);
    setType('');
  };

  useEffect(() => {
    if (isOpenModal) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpenModal]);

  return {
    showModal,
    hideModal,
    isOpenModal,
    modalTitle: title,
    modalType: type
  };
};
